export const FATHER_NAME_REQUIRED = 'Please enter the name of the father.';
export const FATHER_MOBILE_REQUIRED =
  'Please enter the mobile no of the father.';

export const MOTHER_NAME_REQUIRED = 'Please enter the name of the mother.';

export const MOTHER_MOBILE_REQUIRED =
  'Please enter the mobile no of the mother.';
